import { object as yupObject } from 'yup'

export const validate_userExT = async (payload): Promise<boolean> => {
  const userExT_schema = yupObject().shape({})
  const valid = await userExT_schema.isValid(payload)
  return valid
}
